import { Wrench, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function DealerSection() {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="dealer-section" className="py-20 px-4 bg-[#0A0A0A] border-t border-[#1A1A1A]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl text-white font-bold mb-3 font-['Orbitron'] tracking-wide">Officieel Dealer</h2>
          <p className="text-[#8A8A8A] max-w-xl mx-auto text-sm">Naast performance tuning leveren wij ook originele en high-performance motoronderdelen</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-10">
          {/* Wossner */}
          <div data-testid="dealer-wossner" className="relative overflow-hidden bg-[#111] border border-[#1E1E1E] rounded-2xl p-8 hover:border-[#FF3B30]/40 transition-all duration-500 group">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#FF3B30]/5 rounded-full blur-3xl group-hover:bg-[#FF3B30]/10 transition-all"></div>
            <div className="relative">
              <div className="flex items-center gap-4 mb-5">
                <img src="/logos/wossner.png" alt="Wössner Pistons" className="h-12 w-auto" data-testid="wossner-logo" />
                <div>
                  <p className="text-[#FF3B30] text-xs font-semibold uppercase tracking-wider">Authorized Dealer</p>
                </div>
              </div>
              <p className="text-[#8A8A8A] text-sm leading-relaxed mb-4">
                Gesmede zuigers, drijfstangen en complete motorsets van Wossner. Duits vakmanschap voor serieuze motorbuilds — van straatauto tot volle raceauto.
              </p>
              <ul className="space-y-2 mb-6">
                {["Forged pistons (alle maten & overbore)", "H-beam & I-beam drijfstangen", "Piston & rod kits op maat", "Alle auto- en motormerken"].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-[#B0B0B0] text-sm">
                    <span className="w-1.5 h-1.5 bg-[#FF3B30] rounded-full flex-shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
              <Button onClick={scrollToContact} className="bg-[#FF3B30] hover:bg-[#E0342A] text-white text-sm px-6 py-2.5 rounded-lg font-semibold" data-testid="wossner-contact-btn">
                <MessageSquare size={15} className="mr-2" /> Offerte aanvragen
              </Button>
            </div>
          </div>

          {/* OEM Parts */}
          <div data-testid="dealer-oem" className="relative overflow-hidden bg-[#111] border border-[#1E1E1E] rounded-2xl p-8 hover:border-[#FF3B30]/40 transition-all duration-500 group">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#3498DB]/5 rounded-full blur-3xl group-hover:bg-[#3498DB]/10 transition-all"></div>
            <div className="relative">
              <div className="flex items-center gap-4 mb-5">
                <div className="h-12 px-5 bg-[#3498DB] rounded-lg flex items-center justify-center">
                  <span className="text-white text-2xl font-black tracking-wider" style={{ fontFamily: "'Orbitron', sans-serif" }}>OEM</span>
                </div>
                <div>
                  <p className="text-[#3498DB] text-xs font-semibold uppercase tracking-wider">Auto &amp; Motor</p>
                </div>
              </div>
              <p className="text-[#8A8A8A] text-sm leading-relaxed mb-4">
                Originele fabrieksonderdelen voor alle auto- en motormerken. Van filters en remmen tot complete motoronderdelen — wij leveren het juiste onderdeel voor jouw voertuig.
              </p>
              <ul className="space-y-2 mb-6">
                {["Originele fabrieksonderdelen", "Alle auto- en motormerken", "Op kenteken bestellen", "Scherpe dealerprijzen"].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-[#B0B0B0] text-sm">
                    <span className="w-1.5 h-1.5 bg-[#3498DB] rounded-full flex-shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
              <Button onClick={scrollToContact} className="bg-[#3498DB] hover:bg-[#2980B9] text-white text-sm px-6 py-2.5 rounded-lg font-semibold" data-testid="oem-contact-btn">
                <MessageSquare size={15} className="mr-2" /> Onderdeel opvragen
              </Button>
            </div>
          </div>
        </div>

        <p className="text-center text-[#555] text-xs">
          Stuur ons je kenteken, merk, model en motortype via het contactformulier — wij zoeken het juiste onderdeel voor je op.
        </p>
      </div>
    </section>
  );
}
